import { type ActionType, createAction } from 'typesafe-actions';

export const toggleAssetPickerSortMenuOpen = createAction('assetPicker/TOGGLE_SORT_MENU_OPEN')();
export const openAssetPicker = createAction('assetPicker/OPEN')();
export const closeAssetPicker = createAction('assetPicker/CLOSE')();

export type AssetPickerActions =
  | ActionType<typeof toggleAssetPickerSortMenuOpen>
  | ActionType<typeof openAssetPicker>
  | ActionType<typeof closeAssetPicker>;
